import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/Home";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import GalleryDetail from "@/pages/GalleryDetail";
import SinanErdem from "@/pages/SinanErdem";
import Basket from "@/pages/Basket";
import BasketDetail from "@/pages/BasketDetail";
import FanClub from "@/pages/FanClub";
import FanClubDetail from "@/pages/FanClubDetail";
import FanClubSuccess from "@/pages/FanClubSuccess";
import Ticket from "@/pages/Ticket";
import Account from "@/pages/Account";
import Profile from "@/pages/Profile";
import AccountSettings from "@/pages/AccountSettings";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Help from "@/pages/Help";
import Register from "@/pages/Register";
import Fixture from "@/pages/Fixture";
import CheckInSuccess from "@/pages/CheckInSuccess";
import Team from "@/pages/Team";
import Player from "@/pages/Player";
import Statistics from "@/pages/Statistics";
import Success from "@/pages/Success";
import HomeAfterMatch from "@/components/HomeAfterMatch";
import Activate from "@/pages/Activate";
import Contact from "@/pages/Contact";
import ChangePassword from "@/pages/ChangePassword";
import Caylak from "@/pages/Caylak";
import SosyalSorumlulukProjeleri from "@/pages/SosyalSorumlulukProjeleri";
import GuvenlikKamerasiAydinlatmaMetni from "@/pages/GuvenlikKamerasiAydinlatmaMetni";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/haberler",
      name: "News",
      component: News
    },
    {
      path: "/haber/:slug",
      name: "NewsDetail",
      component: NewsDetail,
      scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
      }
    },
    {
      path: "/fan-club",
      name: "FanClub",
      component: FanClub
    },
    {
      path: "/takim/anadolu-efes",
      name: "Team",
      component: Team
    },
    {
      path: "/istatistik",
      name: "Statistics",
      component: Statistics
    },
    {
      path: "/takim/oyuncu/:slug",
      name: "Player",
      component: Player
    },
    {
      path: "/fan-club-detay/:slug",
      name: "FanClubDetail",
      component: FanClubDetail
    },
    {
      path: "/fan-club-tebrikler",
      name: "FanClubSuccess",
      component: FanClubSuccess
    },
    {
      path: "/success",
      name: "Success",
      component: Success
    },
    {
      path: "/check-in",
      name: "CheckInSuccess",
      component: CheckInSuccess
    },
    {
      path: "/basket-tv",
      name: "Basket",
      component: Basket
    },
    {
      path: "/video/:slug",
      name: "BasketDetail",
      component: BasketDetail
    },
    {
      path: "/fikstur",
      name: "Fixture",
      component: Fixture
    },
    {
      path: "/kulup/sinan-erdem-spor-salonu",
      name: "SinanErdem",
      component: SinanErdem
    },
    {
      path: "/kulup/caylak",
      name: "Caylak",
      component: Caylak
    },
    {
      path: "/kulup/sosyal-sorumluluk-projeleri",
      name: "SosyalSorumlulukProjeleri",
      component: SosyalSorumlulukProjeleri
    },
    {
      path: "/guvenlik-kamerasi-aydinlatma-metni",
      name: "GuvenlikKamerasiAydinlatmaMetni",
      component: GuvenlikKamerasiAydinlatmaMetni
    },
    {
      path: "/yardim",
      name: "Help",
      component: Help
    },
    {
      path: "/biletler",
      name: "Ticket",
      component: Ticket
    },
    {
      path: "/hesabim",
      name: "Account",
      component: Account
    },
    {
      path: "/uyelik/guncelle",
      name: "AccountSettings",
      component: AccountSettings
    },
    {
      path: "/uyelik/giris",
      name: "Login",
      component: Login
    },
    {
      path: "/uyelik/kayit",
      name: "Register",
      component: Register
    },
    {
      path: "/uyelik/parola-yenile",
      name: "ForgotPassword",
      component: ForgotPassword
    },
    {
      path: "/fikstur/mac/:id",
      name: "HomeAfterMatch",
      component: HomeAfterMatch
    },
    {
      path: "/uyelik/aktivasyon",
      name: "Activate",
      component: Activate
    },
    {
      path: "/fan-club/uye/:id/:slug",
      name: "UserProfile",
      component: Profile
    },
    {
      path: "/foto-galeri/:slug",
      name: "GalleryDetail",
      component: GalleryDetail
    },
    {
      path: "/iletisim",
      name: "Contact",
      component: Contact
    },
    {
      path: "/uyelik/parola-degistir",
      name: "ChangePassword",
      component: ChangePassword
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js